var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-cashout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 2.375V8.5645L15.4697 5.8448C15.7627 5.5518 16.2373 5.5518 16.5302 5.8448C16.8231 6.1378 16.8232 6.6124 16.5302 6.9053L12.5302 10.9053C12.3837 11.0518 12.1923 11.125 11.9999 11.125C11.8075 11.125 11.6161 11.0518 11.4696 10.9053L7.4697 6.9053C7.1767 6.6123 7.1767 6.1377 7.4697 5.8448C7.7627 5.5519 8.2373 5.5518 8.5302 5.8448L11.2499 8.5645V2.375C11.2499 1.9609 11.5858 1.625 11.9999 1.625C12.414 1.625 12.75 1.9609 12.75 2.375ZM22 10.375V20.375C22 21.4796 21.1046 22.375 20 22.375H4C2.8954 22.375 2 21.4796 2 20.375V10.375C2 9.2704 2.8954 8.375 4 8.375H5.6364C6.1669 8.375 6.6755 8.5857 7.0506 8.9608L10.2324 12.1426C11.2086 13.1188 12.7914 13.1188 13.7676 12.1426L16.9494 8.9608C17.3245 8.5857 17.8332 8.375 18.3636 8.375H20C21.1046 8.375 22 9.2704 22 10.375ZM7.75 15.375C7.75 14.9609 7.4141 14.625 7 14.625H5C4.5859 14.625 4.25 14.9609 4.25 15.375C4.25 15.7891 4.5859 16.125 5 16.125H7C7.4141 16.125 7.75 15.7891 7.75 15.375ZM14 15.375C14 14.2704 13.1046 13.375 12 13.375C10.8954 13.375 10 14.2704 10 15.375C10 16.4796 10.8954 17.375 12 17.375C13.1046 17.375 14 16.4796 14 15.375ZM19.75 15.375C19.75 14.9609 19.4141 14.625 19 14.625H17C16.5859 14.625 16.25 14.9609 16.25 15.375C16.25 15.7891 16.5859 16.125 17 16.125H19C19.4141 16.125 19.75 15.7891 19.75 15.375Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.f7b98b5685f999ab79a0451ab6288bc2.svg";
export { ForwardRef as ReactComponent };